export class colorHelper {
    stringToRgb(color: string): RGB {
        let tmp = color.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);

        if (tmp != null && tmp.length >= 3) {
            return {
                r: parseInt(tmp[1]),
                g: parseInt(tmp[2]),
                b: parseInt(tmp[3])
            };
        }
        tmp = color.match(/^rgba\((\d+),\s*(\d+),\s*(\d+),\s*(\d+)\)$/);

        if (parseInt(tmp[4]) == 0) {
            return {
                r: 255,
                g: 255,
                b: 255
            }
        }
        return {
            r: parseInt(tmp[1]),
            g: parseInt(tmp[2]),
            b: parseInt(tmp[3])
        };
    }

    rgbToHsl(r: number, g: number, b: number): HSL {
        r /= 255;
        g /= 255;
        b /= 255;
        const l = Math.max(r, g, b);
        const s = l - Math.min(r, g, b);
        const h = s
            ? l === r
                ? (g - b) / s
                : l === g
                    ? 2 + (b - r) / s
                    : 4 + (r - g) / s
            : 0;
        return {
            h: Math.round(60 * h < 0 ? 60 * h + 360 : 60 * h),
            s: Math.round(100 * (s ? (l <= 0.5 ? s / (2 * l - s) : s / (2 - (2 * l - s))) : 0)),
            l: Math.round((100 * (2 * l - s)) / 2)
        };
    }

    hexToRgb(hex: string): RGB {
        const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hex = hex.replace(shorthandRegex, function (m, r, g, b) {
            return r + r + g + g + b + b;
        });

        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    }

    luminance(r: number, g: number, b: number): number {
        const a = [r, g, b].map((v) => {
            v /= 255;
            return v <= 0.03928
                ? v / 12.92
                : Math.pow((v + 0.055) / 1.055, 2.4);
        });
        return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
    }

    calculateRatio(color1Rgb: RGB, color2Rgb: RGB): number {
        const color1Luminance = this.luminance(color1Rgb.r, color1Rgb.g, color1Rgb.b);
        const color2Luminance = this.luminance(color2Rgb.r, color2Rgb.g, color2Rgb.b);

        const ratio = color1Luminance > color2Luminance
            ? ((color2Luminance + 0.05) / (color1Luminance + 0.05))
            : ((color1Luminance + 0.05) / (color2Luminance + 0.05));

        return ratio;
    }

}

export class RGB {
    r: number;
    g: number;
    b: number;
}

export class HSL {
    h: number;
    s: number;
    l: number;
}